import { type JSX } from "react";

// Originally created for the JSS application codebase.
//
// The component data is currently used by `generateMetadata` in `page.tsx`
// for metadata generation. If this component is modified, please review and
// update the corresponding metadata generation logic as needed.
export const Default = (): JSX.Element => {
  return <></>;
};
